import {Mapper} from '@s-ui/domain'

export default class SearchRequestJSONToCochesParamsJSONMapper extends Mapper {
  constructor({config, parseQueryString, toQueryParams}) {
    super()

    this._config = config
    this._defaultSortBy = this._config.get('SORT_FIELDS').RELEVANCE
    this._defaultSortOrder = this._config.get('ORDER').DESC
    this._bodyTypeCategoryId = this._config.get('search').BODY_TYPE_CATEGORY
    this._sort = this._config.get('search').SORT
    this._defaultOfferType = this._config.get('search').DEFAULT_OFFER_TYPE
    this._defaultVehicleValue = this._config.get('search').DEFAULT_VEHICLE
    this._defaultOptionValue = this._config.get('search').DEFAULT_OPTION_VALUE
    this._filterNames = this._config.get('search').FILTER_NAMES
    this._listingSectionIds = this._config.get('COMMON').LISTING_SECTION_IDS
    this._offerTypeKm0 = this._config.get('search').OFFER_TYPE_KM0
    this._unselectedOfferType = this._config.get('search').UNSELECTED_OFFER_TYPE
    this._offerTypeSecondHand = this._config.get('search').OFFER_TYPE_SECOND_HAND
    this._firstPage = 1
    this._toQueryParams = toQueryParams
    this._parseQueryString = parseQueryString
  }

  setParams = ({
    page = this._firstPage,
    sortBy = this._defaultSortBy,
    sortOrder = this._defaultSortOrder,
    batteryCapacity = {},
    bodyTypeIds = [],
    categoryId,
    category2Id,
    chargingTimeFastMode = {},
    chargingTimeStandardMode = {},
    electricAutonomy = {},
    colorIds = [],
    commitmentMonths = [],
    doors = [],
    drivenWheelsIds = [],
    entry,
    environmentalLabels = [],
    equipments = [],
    filteredOfferTypeId,
    financedPrice,
    fuelTypeIds = [],
    hasPriceDrop,
    hasInstalment,
    hasPhoto,
    hasOnlineFinancing,
    hasReservation,
    hasStock,
    hasWarranty,
    hp = {},
    instalment,
    isCertified,
    kms = {},
    litres = {},
    listingSectionId,
    location = {},
    luggageCapacity,
    maxTerms,
    makeId,
    model = {},
    monthlySubscriptionFee = {},
    offerTypeId,
    onlyPeninsula,
    price = {},
    priceDrop,
    priceRank = [],
    provinceIds = [],
    rating = {},
    searchText,
    seats = [],
    sellerTypeId,
    subscriptionVehicleState,
    targetBuyer,
    transmissionTypeId,
    vehicles = [],
    version,
    year = {}
  }) => {
    this._page = page
    this._sortBy = this._sort[sortBy]?.queryParam
    this._sortOrder = sortOrder
    this._isDefaultSort =
      this._sortBy !== this._sort[this._defaultSortBy].queryParam || this._sortOrder !== this._defaultSortOrder

    this._bodyTypeIds = bodyTypeIds
    this._batteryCapacity = batteryCapacity
    this._categoryId = categoryId
    this._category2Id = category2Id
    this._chargingTimeFastMode = chargingTimeFastMode
    this._chargingTimeStandardMode = chargingTimeStandardMode
    this._colorIds = colorIds
    this._commitmentMonths = commitmentMonths
    this._doors = doors
    this._drivenWheelsIds = drivenWheelsIds
    this._electricAutonomy = electricAutonomy
    this._entry = entry
    this._environmentalLabels = environmentalLabels
    this._equipments = equipments
    this._filteredOfferTypeId = filteredOfferTypeId
    this._financedPrice = financedPrice
    this._fuelTypeIds = fuelTypeIds
    this._hasPriceDrop = hasPriceDrop
    this._hasInstalment = hasInstalment
    this._hasPhoto = hasPhoto
    this._hasOnlineFinancing = hasOnlineFinancing
    this._hasReservation = hasReservation
    this._hasStock = hasStock
    this._hasWarranty = hasWarranty
    this._hp = hp
    this._instalment = instalment
    this._isCertified = isCertified
    this._kms = kms
    this._listingSectionId = listingSectionId
    this._litres = litres
    this._location = location
    this._luggageCapacity = luggageCapacity
    this._makeId = makeId
    this._maxTerms = maxTerms
    this._model = model
    this._monthlySubscriptionFee = monthlySubscriptionFee
    this._offerTypeId = offerTypeId
    this._onlyPeninsula = onlyPeninsula
    this._price = price
    this._priceDrop = priceDrop
    this._priceRank = priceRank
    this._provinceIds = provinceIds
    this._rating = rating
    this._searchText = searchText
    this._seats = seats
    this._sellerTypeId = sellerTypeId
    this._subscriptionVehicleState = subscriptionVehicleState
    this._targetBuyer = targetBuyer
    this._transmissionTypeId = transmissionTypeId
    this._vehicles = vehicles
    this._version = version
    this._year = year

    return this
  }

  _getPriceFromParam = hasInstalment => {
    return hasInstalment ? 'MinInstalmentPrice' : 'MinPrice'
  }

  _getPriceToParam = hasInstalment => {
    return hasInstalment ? 'MaxInstalmentPrice' : 'MaxPrice'
  }

  // tech debt transaction b2c: we need this MTR-58079 task to be done, to not need to send from value to be able to filter for all instalment ads
  _getMinInstalment = (hasInstalment, isInstalmentRangeUndefined) => {
    if (hasInstalment && isInstalmentRangeUndefined) return 1
    return this._instalment?.from || null
  }

  _getPriceParams = hasInstalment => {
    const isInstalmentRangeUndefined = this._instalment?.from === null && this._instalment?.to === null

    const priceFromParam = this._getPriceFromParam(hasInstalment)
    const priceToParam = this._getPriceToParam(hasInstalment)

    const typePrice = hasInstalment ? this._instalment : this._price

    const priceFrom = hasInstalment
      ? this._getMinInstalment(hasInstalment, isInstalmentRangeUndefined)
      : this._price.from

    return {
      [priceFromParam]: this._avoidDefaultValue(priceFrom),
      [priceToParam]: this._avoidDefaultValue(typePrice?.to),
      hasInstalment: this._hasInstalment === true ? this._hasInstalment : undefined
    }
  }

  map = () => ({
    pg: this._page > this._firstPage ? this._page : undefined,
    ...this._getPriceParams(this._hasInstalment),
    ...this._getVehicleParams(this._vehicles || []),
    ArrBodyType: this._parseArrayFilter(this._bodyTypeIds),
    arrProvince: this._parseArrayFilter(this._provinceIds),
    minBatteryCapacity: this._batteryCapacity.from || undefined,
    minElectricAutonomy: this._electricAutonomy.from || undefined,
    maxBatteryCapacity: this._batteryCapacity.to || undefined,
    maxChargingTimeFastMode: this._chargingTimeFastMode.to || undefined,
    maxChargingTimeStandardMode: this._chargingTimeStandardMode.to || undefined,
    certification: this._getIsCertified(),
    ColourId: this._parseArrayFilter(this._colorIds),
    commitmentMonths: this._parseZeroAllowedArrayFilter(this._commitmentMonths),
    DrivenWheelsIds: this._parseArrayFilter(this._drivenWheelsIds),
    entry: this._hasInstalment ? this._avoidDefaultValue(this._entry) : undefined,
    EnvironmentalLabels: this._parseArrayFilter(this._environmentalLabels),
    Equipments: this._parseArrayFilter(this._equipments),
    fi: this._isDefaultSort ? this._sortBy : undefined,
    Fueltype2List: this._parseArrayFilter(this._fuelTypeIds),
    hasPhoto: this._avoidDefaultValue(this._hasPhoto),
    hasOnlineFinancing: this._avoidDefaultValue(this._hasOnlineFinancing),
    hasPriceDrop: this._avoidDefaultValue(this._hasPriceDrop),
    hasReservation: this._avoidDefaultValue(this._hasReservation),
    hasStock: this._avoidDefaultValue(this._hasStock),
    KeyWords: this._avoidDefaultValue(this._searchText),
    locationDistance: this._avoidDefaultValue(this._location.radio),
    locationLat: this._avoidDefaultValue(this._location.lat),
    locationLong: this._avoidDefaultValue(this._location.long),
    locationText: this._avoidDefaultValue(this._location.text),
    locationProvinceId: this._avoidDefaultValue(this._location.provinceId),
    LuggageCapacityTypeId: this._getLuggageCapacityId(),
    maxDoors: this._doors.to || undefined,
    maxFee: this._avoidDefaultValue(this._monthlySubscriptionFee.to),
    MaxKms: this._avoidDefaultValue(this._kms.to),
    MaxLitres: this._litres.to || undefined,
    maxRating: this._rating.to || undefined,
    maxSeats: this._seats.to || undefined,
    maxTerms: this._hasInstalment ? this._avoidDefaultValue(this._maxTerms) : undefined,
    MaxYear: this._avoidDefaultValue(this._year.to),
    minDoors: this._doors.from || undefined,
    minFee: this._avoidDefaultValue(this._monthlySubscriptionFee.from),
    MinKms: this._avoidDefaultValue(this._kms.from),
    MinLitres: this._litres.from || undefined,
    minRating: this._rating.from || undefined,
    minSeats: this._seats.from || undefined,
    MinYear: this._avoidDefaultValue(this._year.from),
    OfferType: this._getOfferType(),
    onlyPeninsula: this._avoidDefaultValue(this._onlyPeninsula),
    or: this._isDefaultSort ? this._getSortOrderParam() : undefined,
    PowerHpFrom: this._avoidDefaultValue(this._hp.from),
    PowerHpTo: this._avoidDefaultValue(this._hp.to),
    priceRank: this._parseArrayFilter(this._priceRank),
    Section1Id: this._avoidDefaultValue(this._categoryId),
    Section2Id: this._avoidDefaultValue(this._category2Id),
    st: this._avoidDefaultValue(this._sellerTypeId),
    targetBuyer: this._avoidDefaultValue(this._targetBuyer),
    TransmissionTypeId: this._avoidDefaultValue(this._transmissionTypeId),
    vehicleState: this._avoidDefaultValue(this._subscriptionVehicleState),
    wwa: this._avoidDefaultValue(this._hasWarranty)
  })

  _getIsDefaultValue = value => value === this._defaultOptionValue || value === String(this._defaultOptionValue)

  _getParamValue = ({currentValue, fallbackValue, defaultValue}) => {
    const isDefaultValueFromVehicle = this._getIsDefaultValue(currentValue)

    if (isDefaultValueFromVehicle) return defaultValue

    if (currentValue) return currentValue

    const isDefaultValueFromSearch = this._getIsDefaultValue(fallbackValue)

    if (isDefaultValueFromSearch) return defaultValue

    return fallbackValue || defaultValue
  }

  _getVehicleParam = ({currentValue, defaultValue, fallbackValue, prevValue}) => [
    ...prevValue,
    this._getParamValue({currentValue, defaultValue, fallbackValue})
  ]

  _getVehicleParams = vehicles => {
    const queryParams = vehicles.reduce(
      (acc, {makeId, modelId, model = {}, version}) => {
        acc.MakeIds = this._getVehicleParam({
          currentValue: makeId,
          defaultValue: this._defaultVehicleValue[this._filterNames.MAKE],
          fallbackValue: this._makeId,
          prevValue: acc.MakeIds
        })
        acc.ModelIds = this._getVehicleParam({
          currentValue: modelId || model.id,
          defaultValue: this._defaultVehicleValue[this._filterNames.MODEL].id,
          fallbackValue: this._model.id,
          prevValue: acc.ModelIds
        })
        acc.Versions = this._getVehicleParam({
          currentValue: version,
          defaultValue: this._defaultVehicleValue[this._filterNames.VERSION],
          fallbackValue: this._version,
          prevValue: acc.Versions
        })
        return acc
      },
      {MakeIds: [], ModelIds: [], Versions: []}
    )

    return queryParams
  }

  _getLuggageCapacityId = () => {
    const {luggageCapacityTypes} = this._config.get('search')

    const selectedLuggageCapacity = luggageCapacityTypes.find(
      type => JSON.stringify(type.value) === JSON.stringify(this._luggageCapacity)
    )

    return this._luggageCapacity && selectedLuggageCapacity ? selectedLuggageCapacity.id : undefined
  }

  _getIsCertified = () => (this._isCertified ? '0' : undefined)

  /**
   * If value is 0 param should not exist, then there shouldn't appear in URL
   */
  _avoidDefaultValue = value => value || undefined

  _getSortOrderParam = () => (this._sortOrder === this._defaultSortOrder ? -1 : 1)

  _getOfferType = () => {
    const defaultOfferType =
      this._listingSectionId === this._listingSectionIds.ALL_VEHICLES || this._offerTypeId === this._offerTypeKm0
        ? this._unselectedOfferType
        : this._offerTypeSecondHand

    const selectedValue =
      typeof this._filteredOfferTypeId === 'number' && this._filteredOfferTypeId !== defaultOfferType
        ? this._filteredOfferTypeId
        : undefined

    return selectedValue
  }

  /**
   * Avoid 0 values in URL
   * Array should appear as "pipe" separated strings in URL
   */
  _parseArrayFilter = (array = []) => {
    return array.filter(Boolean).length > 0 ? array.join('|') : undefined
  }

  /**
   * Do not avoid 0 values in URL for some cases (no commitment ie 0 IS a valid value)
   * Array should appear as "pipe" separated strings in URL
   */
  _parseZeroAllowedArrayFilter = (array = []) => (array.length > 0 ? array.join('|') : undefined)
}
